// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1iPyb","buttons":"PendingPaymentAlert_buttons__3xasR"};